import { concat, indexOf } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { navigateTo } from 'gatsby-link';

import { buttonPress } from '../services/vibration';

import Header from '../components/Header';
import Menu from '../components/Menu';
import Footer from '../components/Footer';

import '../../sass/styles.scss';

class TemplateWrapper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      children: ['home', 'contact'],
      direction: null,
      leftOffset: 0,
      position: 0,
    };
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handlePreviousClick = this.handlePreviousClick.bind(this);
    this.setChildren = this.setChildren.bind(this);
    this.setLeftOffset = this.setLeftOffset.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const position = indexOf(
      this.state.children,
      nextProps.location.hash.slice(1)
    );
    if (position >= 0) {
      this.setState({ direction: this.direction(position), position });
    } else {
      this.setState({
        direction: this.direction(0),
        position: 0,
      });
    }
  }

  setChildren(slugs) {
    const { hash } = this.props.location;
    const children = concat('home', slugs, 'contact');
    if (hash.length) {
      const position = indexOf(children, hash.slice(1));
      if (position >= 0) {
        this.setState({
          children,
          position,
        });
      } else {
        this.setState({ children });
      }
    } else {
      this.setState({ children });
    }
  }

  setLeftOffset(leftOffset) {
    if (leftOffset !== this.state.leftOffset) {
      this.setState({ leftOffset });
    }
  }

  direction(newPosition) {
    if (newPosition < this.state.position) {
      return 'to-the-left';
    } else if (newPosition > this.state.position) {
      return 'to-the-right';
    }
    return null;
  }

  handlePreviousClick(event) {
    const { position } = this.state;
    if (position > 0) {
      buttonPress(event);
      navigateTo(`/#${this.state.children[position - 1]}`);
    }
  }

  handleNextClick(event) {
    const { children, position } = this.state;
    if (position < children.length - 1) {
      buttonPress(event);
      navigateTo(`/#${this.state.children[position + 1]}`);
    }
  }

  scrollStyle() {
    const { leftOffset, position } = this.state;
    return {
      left: `calc(${position * -100}vw + ${leftOffset}px)`,
    };
  }

  render() {
    const { children, data, location } = this.props;
    const { site } = data;
    const { siteMetadata } = site;
    return (
      <div id="root">
        <Helmet
          title={`${siteMetadata.siteMotto} by ${siteMetadata.title}`}
          link={[
            {
              rel: 'icon',
              type: 'image/png',
              href: '/images/favicons/favicon-16x16.png',
              sizes: '16x16',
            },
            {
              rel: 'icon',
              type: 'image/png',
              href: '/images/favicons/favicon-32x32.png',
              sizes: '32x32',
            },
            {
              rel: 'icon',
              type: 'image/png',
              href: '/images/favicons/favicon-96x96.png',
              sizes: '96x96',
            },
            {
              rel: 'apple-touch-icon',
              href: '/images/favicons/apple-touch-icon-120x120.png',
              sizes: '120x120',
            },
            {
              rel: 'apple-touch-icon',
              href: '/images/favicons/apple-touch-icon-152x152.png',
              sizes: '152x152',
            },
            {
              rel: 'apple-touch-icon',
              href: '/images/favicons/apple-touch-icon-167x167.png',
              sizes: '167x167',
            },
            {
              rel: 'apple-touch-icon',
              href: '/images/favicons/apple-touch-icon-180x180.png',
              sizes: '180x180',
            },
          ]}
          meta={[
            {
              name: 'msapplication-TileColor',
              content: '#ffffff',
            },
            {
              name: 'msapplication-TileImage',
              content: '/browserconfig.xml',
            },
            {
              name: 'description',
              content: siteMetadata.siteDescription,
            },
            {
              name: 'keywords',
              content: siteMetadata.siteKeywords,
            },
            {
              name: 'twitter:title',
              content: 'Sites Made for People : mckelvey/creative',
            },
            {
              property: 'og:title',
              content: 'Sites Made for People : mckelvey/creative',
            },
            {
              name: 'twitter:image',
              content: '/images/favicons/share.png',
            },
            {
              property: 'og:image',
              content: '/images/favicons/share.png',
            },
            {
              property: 'og:image:width',
              content: '1200',
            },
            {
              property: 'og:image:height',
              content: '630',
            },
            {
              name: 'twitter:image:alt',
              content: 'Sites Made for People : mckelvey/creative',
            },
            {
              name: 'twitter:description',
              content: siteMetadata.siteDescription,
            },
            {
              property: 'og:description',
              content: siteMetadata.siteDescription,
            },
            {
              property: 'og:type',
              content: 'website',
            },
            {
              property: 'og:site_name',
              content: 'Sites Made for People : mckelvey/creative',
            },
            {
              property: 'og:url',
              content: 'https://sitesmade4people.co/',
            },
            {
              name: 'twitter:site',
              content: '@mckelvey',
            },
            {
              name: 'twitter:card',
              content: 'summary_large_image',
            },
          ]}
          script={[
            {
              type: 'text/javascript',
              innerHTML:
                '(function(d) {' +
                '  var config = {' +
                '      kitId: "ghw7pnb",' +
                '      scriptTimeout: 3000,' +
                '      async: true,' +
                '      active: function(){ window.dispatchEvent(new Event("resize")); }' +
                '    },' +
                '    h=d.documentElement,' +
                '    t=setTimeout(function(){' +
                '      h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";' +
                '    },' +
                '    config.scriptTimeout),' +
                '    tk=d.createElement("script"),' +
                '    f=false,' +
                '    s=d.getElementsByTagName("script")[0],' +
                '    a;' +
                '  h.className+=" wf-loading";' +
                '  tk.src="https://use.typekit.net/"+config.kitId+".js";' +
                '  tk.async=true;' +
                '  tk.onload=tk.onreadystatechange=function(){' +
                '    a=this.readyState;' +
                '    if(f||a&&a!="complete"&&a!="loaded")return;' +
                '    f=true;' +
                '    clearTimeout(t);' +
                '    try{Typekit.load(config)}catch(e){}' +
                '  };' +
                '  s.parentNode.insertBefore(tk,s)' +
                '})(document);',
            },
          ]}
        />
        <Menu
          {...siteMetadata}
          canMoveNext={this.state.position < this.state.children.length - 1}
          canMovePrevious={this.state.position > 0}
          handleNextClick={this.handleNextClick}
          handlePreviousClick={this.handlePreviousClick}
        />
        <div
          className={this.state.direction}
          id="content"
          style={this.scrollStyle()}
          ref={node => {
            this.contentNode = node;
          }}
        >
          <Header
            {...siteMetadata}
            handleNextClick={this.handleNextClick}
            handlePreviousClick={this.handlePreviousClick}
            location={location}
            setLeftOffset={this.setLeftOffset}
            slug="home"
          />
          <main>
            {children({
              ...this.props,
              handleNextClick: this.handleNextClick,
              handlePreviousClick: this.handlePreviousClick,
              setChildren: this.setChildren,
              setLeftOffset: this.setLeftOffset,
            })}
          </main>
          <Footer
            {...siteMetadata}
            handleNextClick={this.handleNextClick}
            handlePreviousClick={this.handlePreviousClick}
            location={location}
            setLeftOffset={this.setLeftOffset}
            slug="contact"
          />
        </div>
      </div>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        siteDescription: PropTypes.string.isRequired,
        siteKeywords: PropTypes.string.isRequired,
        siteMotto: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

TemplateWrapper.defaultProps = {
  children: () => null,
};

export default TemplateWrapper;

// eslint-disable-next-line no-undef
export const query = graphql`
  query SiteQuery {
    site {
      siteMetadata {
        siteDescription
        siteKeywords
        siteMotto
        title
        vCard {
          fullName
          physicalAddress {
            streetAddress
            locality
            region
            postalCode
            country {
              abbr
              title
            }
          }
          emailAddress
          phoneNumber
          socialMedia {
            profileUrl
            serviceName
            slug
            username
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js